var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "affiliation-error-page" },
    [
      _c("LockedYellowGreen", {
        staticClass: "affiliation-error-page__illustration"
      }),
      _vm._v(" "),
      _c(
        "h1",
        {
          staticClass:
            "typographies-display-medium affiliation-error-page__title"
        },
        [
          _vm._v(
            "\n        " + _vm._s(_vm.$l10n.__("Accès en attente")) + "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("p", {
        staticClass:
          "typographies-paragraph-x-large-regular affiliation-error-page__text",
        domProps: { innerHTML: _vm._s(_vm.affiliationText) }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }